import axios from "axios";
import utils from "@/services/utils";

export default {
  async search(searchOptions) {
    try {
      const response = await axios.get("/sighting/groups", {
        params: {
          ...utils.buildApiSearchQuery(searchOptions, "email", false),
          start_date: searchOptions.startDate,
          end_date: searchOptions.endDate,
          species: searchOptions.species.join(";"),
        },
      });
      const data = response.data;
      return { message: "Got sightings", data: data.items, total: data.total };
    } catch (e) {
      return { message: "No sightings found", data: [], total: 0 };
    }
  },
};
